<template>
    <b-modal
            v-if="hasQuestion"
            id="survey-question-modal"
            ref="survey-question-modal"
            @hidden="hide()"
            class="modal--survey"
            centered
            hide-footer
            :title="question.question.question"
    >
        <survey-question
                display="md"
                :question="question.question"
                @submit="$refs['survey-question-modal'].hide()"
        />
    </b-modal>
</template>
<style lang="scss">
    $paddingY: 2.5%;
    $borderRadius: 0.5em;
    .modal--survey {
        .modal-content {
            /*padding: $paddingY 0;
            border-radius: $borderRadius;
            border: 1px solid var(--secondary);*/
        }
    }
</style>
<script>
    import SurveyQuestion from "./Question";

    export default {
        name: 'survey-popup',
        components: {SurveyQuestion},
        mounted() {
            if (this.hasQuestion)
                this.$refs['survey-question-modal'].show()
        },
        methods: {
            async hide() {
                await this.$store.dispatch('base/survey/post', {
                    questionId: this.question.question.id,
                    answer: 'no_answer'
                })
            }
        },
        computed: {
            hasQuestion() {
                return this.question && this.question.question
            },
            question() {
                return this.$store.state.base.survey.question
            }
        }
    }
</script>
